import { type Component, Show } from 'solid-js'
import SwipeAction from '~/components/SwipeAction'
import { type LineType, lineSubtotal } from './line'

export interface LineSwipeCardPropsType {
  line: LineType
  index: number
  formatMoney: (value: number) => string
  onEdit: (index: number) => void
  onDuplicate: (index: number) => void
  onRemove: (index: number) => void
}

/** Línea en tarjeta deslizable (móvil): al tocar edita, con acciones de duplicar/quitar. */
const LineSwipeCard: Component<LineSwipeCardPropsType> = props => {
  return (
    <SwipeAction
      itemId={`line-${props.index}`}
      rememberPosition
      onClick={() => props.onEdit(props.index)}
      leftOptions={[{ icon: 'material-symbols-light:edit-outline', action: () => props.onEdit(props.index), color: 'warning', label: 'Editar' }]}
      rightOptions={[
        { icon: 'material-symbols-light:content-copy-outline', action: () => props.onDuplicate(props.index), color: 'default', label: 'Duplicar' },
        { icon: 'material-symbols-light:delete-outline', action: () => props.onRemove(props.index), color: 'danger', label: 'Quitar' }
      ]}
    >
      <div class="rounded-lg border border-border px-4 py-3 bg-surface">
        <div class="flex items-center justify-between gap-2">
          <span class="font-medium text-foreground truncate">{props.line.description || 'Sin concepto'}</span>
          <span class="text-sm font-semibold text-foreground shrink-0">{props.formatMoney(lineSubtotal(props.line))}</span>
        </div>
        <p class="text-xs text-foreground-subtle mt-0.5 truncate">
          {props.line.quantity} × {props.formatMoney(props.line.unitPrice)}
          <Show when={props.line.discount > 0}>
            <span> · desc {props.line.discountType === 'percent' ? `${props.line.discount}%` : props.formatMoney(props.line.discount)}</span>
          </Show>
        </p>
      </div>
    </SwipeAction>
  )
}

export default LineSwipeCard
